<template>
    <div class="conferencePage" v-if="data && data.page">
        <div class="workshopCont">
            <div class="workshop">
                <div class="programmeBlock" v-for="workshop in data?.page.workshops">
                    <h2 class="helvetica title3">{{ workshop.title }}</h2>
                    <div class="dayBlock">
                        <div class="dayHeader">
                            <div class="day">Day programme</div>
                            <LazyNeverItemConferenceDateDay :day_date="workshop.day_date" hydrate-never />
                        </div>
                        <div class="row" v-for="item in workshop.schedule">
                            <div class="hours baron bodyS">{{ item.time_start.substring(0, 5) }} - {{
                                item.time_end.substring(0, 5) }}</div>
                            <div class="content" v-html="item.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <WebsiteFooter />
    </div>
</template>

<script lang="ts" setup>
const { getConferenceWorkshop } = useConferences();
const route = useRoute()
const { data } = useAsyncData(`conferences-${route.params.slug}-workshop`, () => getConferenceWorkshop(route.params.slug));

useSeoMeta({
    title: () => `Workshop: ${data.value?.page?.title} | Conferences | EIC Federation`,
    ogTitle: () => `Workshop: ${data.value?.page?.title} | Conferences | EIC Federation`,
    twitterTitle: () => `Workshop: ${data.value?.page?.title} | Conferences | EIC Federation`
})
</script>

<style lang="scss" scoped>
.conferencePage {
    .workshopCont {
        padding: 0 var(--size-margin-page);

        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: var(--size-gutter-double) var(--size-margin-page);

        .workshop {
            grid-column: 2;

            display: grid;
            grid-template-columns: repeat(6, minmax(0, 1fr));
            gap: var(--size-gutter-sections) var(--size-margin-page);

            .programmeBlock {
                grid-column: span 5;

                display: flex;
                flex-direction: column;
                gap: var(--size-gutter-double);

                .dayBlock {
                    border-top: var(--size-thickness) solid var(--color-primary);
                    padding-top: var(--size-gutter-default);

                    display: flex;
                    flex-direction: column;
                    gap: var(--size-gutter-default);

                    .dayHeader {
                        display: flex;
                        justify-content: space-between;
                        align-items: baseline;

                        .day {
                            color: var(--color-primary);
                        }
                    }

                    .row {
                        display: grid;
                        grid-template-columns: 130px 1fr;
                        gap: var(--size-margin-page);

                        align-items: baseline;

                        .hours {
                            letter-spacing: var(--text-spacing-header);
                        }

                        .content {

                            &:deep(h4) {
                                font-family: 'HelveticaNowProDisplay', Arial, Helvetica, sans-serif;
                                font-size: var(--text-size-title5);
                                line-height: var(--text-line-title5);
                                font-weight: bold;

                                color: var(--color-primary);
                                margin-bottom: var(--size-gutter-default);
                            }

                            &:deep(a) {
                                color: currentColor;
                                text-underline-offset: 0.1em;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1024px) {
    .conferencePage {
        .workshopCont {
            display: flex;
            grid-template-columns: 1fr;
            gap: 0;

            .workshop {
                display: grid;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                gap: var(--size-gutter-sections) var(--size-margin-page);
            }
        }
    }
}

@media screen and (max-width: 600px) {
    .conferencePage {
        .workshopCont {
            .workshop {
                .programmeBlock {
                    .dayBlock {
                        .row {
                            grid-template-columns: 1fr;
                            gap: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>